<template>
    <div>
        <geometry-element
                :selectable="movingElement"
                :movable="isHexagonalModeling ? false : (!isReadOnly && movingElement)"
                :resizable="isHexagonalModeling ? false : (!isReadOnly && movingElement && isEditElement)"
                :deletable="isHexagonalModeling ? false : (!isReadOnly && isEditElement) "
                connectable
                :id.sync="elementCoordinate.id"
                :x.sync="elementCoordinate.x"
                :y.sync="elementCoordinate.y"
                :width.sync="elementCoordinate.width"
                :height.sync="elementCoordinate.height"
                :angle.sync="elementCoordinate.angle"
                :customMoveActionExist="isCustomMoveExist"
                v-on:customMoveAction="delayedMove"
                v-on:moveShape="onMoveShape"
                v-on:removeShape="onRemoveShape"
                v-on:dblclick="openPanel"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:rotateShape="onRotateShape"
                v-on:addedToGroup="onAddedToGroup"
                :label.sync="getFieldDescriptors ? '': namePanel"
                :image.sync="setImg"
                :_style="{
                'label-angle':value.elementView.angle,
                'font-weight': 'bold', 'font-size': '16',
                }"
        >
            <!--v-on:dblclick="$refs['dialog'].open()"-->
            <geometry-rect
                    v-if="movingElement"
                    :_style="{
          'fill-r': 1,
          'fill-cx': .1,
          'fill-cy': .1,
          'stroke-width': 1.4,
          'stroke': '#F1A746',
          'fill': '#F1A746',
          'fill-opacity': 1,
          'r': '1',
        }">
            </geometry-rect>

            <geometry-rect
                    v-else
                    :_style="{
          'fill-r': 1,
          'fill-cx': .1,
          'fill-cy': .1,
          'stroke-width': 0,
          'stroke': '#F1A746',
          'fill': '#F1A746',
          'fill-opacity': .5,
          'r': '1',
        }">
            </geometry-rect>

            <sub-elements v-if="!isHexagonalModeling"  v-for="(index) in editUserImg.length">
                <image-element
                        v-bind:image="editUserImg[index-1].picture"
                        :sub-width="'24px'"
                        :sub-height="'24px'"
                        :sub-right="(10*(index-1))+'px'"
                        :sub-bottom="value.elementView.height"
                >
                </image-element>
            </sub-elements>

            <sub-elements>
                <geometry-point
                        :coordinate="[95,5]"
                        :_style="statusCompleteStyle">
                </geometry-point>

                <text-element
                        v-if="!isHexagonalModeling"
                        :sub-width="'100%'"
                        :sub-height="titleH"
                        :sub-top="0"
                        :sub-left="0"
                        :text="value.classReference ? value.classReference : '<< Event >>'">
                </text-element>

                <text-element
                        v-if="getFieldDescriptors"
                        :sub-width="'100%'"
                        :sub-height="subjectHeight"
                        :sub-top="subjectTop"
                        :sub-left="0"
                        :subStyle="{'font-size': '16px', 'font-weight': 'bold'}"
                        :text="getNamePanel">
                </text-element>

                <!--                <geometry-line :from="getLineFromTo.from" :to="getLineFromTo.to"></geometry-line>-->

                <text-element
                        class="discStyle"
                        v-if="getFieldDescriptors && !isHexagonalModeling"
                        :sub-width="'120%'"
                        :sub-height="detailHeight"
                        :sub-top="detailTop"
                        :sub-left="detailLeft"
                        :subStyle="{'font-size': '12px', 'text-anchor':'start'}"
                        :text="getFieldDescriptors">
                </text-element>

                <image-element
                        v-if="showValidation"
                        v-bind:image="showValidationImg"
                        :sub-width="'20px'"
                        :sub-height="'20px'"
                        :sub-right="'5px'"
                        :sub-bottom="'5px'"
                >
                </image-element>
                <storming-sub-controller :type="value._type" :value="value"
                                         :readOnly="isReadOnly"></storming-sub-controller>

            </sub-elements>
        </geometry-element>

        <domain-event-definition-panel
                v-if="propertyPanel"
                v-model="value"
                :readOnly="!isEditElement"
                :newEditUserImg="newEditUserImg"
                :image="image"
                :validationLists="filteredElementValidationResults"
                @close="closePanel"
                @changedPanelValue="changedPanelValue"
        ></domain-event-definition-panel>

    </div>
</template>

<script>
    import DomainEventDefinitionPanel from "../panels/DomainEventDefinitionPanel";
    import Element from './EventStormingModelElement'

    var changeCase = require('change-case');
    var pluralize = require('pluralize');

    var Mustache = require('mustache')
    var _ = require('lodash')

    export default {
        mixins: [Element],
        name: 'domain-event-definition',
        components:{DomainEventDefinitionPanel},
        computed: {
            subjectTop() {
                return 30
            },
            subjectHeight() {
                return 8
            },
            detailHeight() {
                var count = null
                if(this.value.elementView.height <= 270){
                    count = this.eventfieldDescriptorsCount
                } else if(this.value.elementView.height > 270){
                    count = this.value.fieldDescriptors.length
                }
                return this.subjectHeight + (count * 5)
            },
            detailLeft() {
                var width = this.value.elementView.width * 0.1
                return width
            },
            detailTop() {
                return this.subjectTop + this.detailHeight
            },
            getFieldDescriptors() {

                if (this.value.fieldDescriptors) {
                    if (this.value.fieldDescriptors.length == 1
                        && this.value.fieldDescriptors[0].name == 'id') {
                        return false
                    }

                    var text = ''
                    var value = 0
                    if(this.value.elementView.height <= 100){
                        value = 42
                    } else if(this.value.elementView.height <= 150){
                        value = 30
                    } else if(this.value.elementView.height <= 270){
                        value = 23
                    } else if(this.value.elementView.height > 270){
                        value = 17
                    }
                    var y = Math.ceil(this.value.elementView.height/value)
                    this.eventfieldDescriptorsCount = y
                    if(this.value.fieldDescriptors.length > y){
                        for(var i = 0; i <= y; i++){
                            if(i == y) text = text + 'ㆍ ' + this.value.fieldDescriptors[i].name + '  ...'
                            else text = text + 'ㆍ ' + this.value.fieldDescriptors[i].name + '\n'
                        }
                    } else {
                        this.value.fieldDescriptors.forEach(function (field) {
                            text = text + 'ㆍ ' + field.name + '\n'
                        })
                    }
                    return text
                    
                }
                return null
            },
            defaultStyle() {
                return {}
            },
            className() {
                return 'org.uengine.modeling.model.Event'
            },
            createNew(elementId, x, y, width, height, description, label) {
                return {
                    _type: 'org.uengine.modeling.model.Event',
                    name: '',
                    oldName: '',
                    namePascalCase: '',
                    nameCamelCase: '',
                    namePlural: '',
                    description: null,
                    author: null,
                    aggregate: {},
                    boundedContext: {},
                    fieldDescriptors: [
                        {
                            _type: "org.uengine.model.FieldDescriptor",
                            name: "id",
                            className: "Long",
                            nameCamelCase: 'id',
                            namePascalCase: 'Id',
                            isKey: true
                        }
                    ],
                    elementView: {
                        '_type': 'org.uengine.modeling.model.Event',
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': 100,
                        'height': 100,
                        'style': JSON.stringify({}),
                        'angle': 0,
                    },
                    hexagonalView:{
                        '_type': 'org.uengine.modeling.model.EventHexagonal',
                        'id': elementId,
                        'x': 0,
                        'y': 0,
                        'width': 0,
                        'height': 0,
                        'style': JSON.stringify({})
                    },
                    alertURL: location.pathname + ((location.pathname == '/' || location.pathname.lastIndexOf('/') > 0) ? '' : '/') + 'static/image/symbol/alert-icon.png',
                    checkAlert: true,
                    relationPolicyInfo: [],
                    relationCommandInfo: [],
                    trigger: '@PostPersist',
                }
            },

        },
        data: function () {
            return {
                eventfieldDescriptorsCount: 0,
                itemH: 20,
                titleH: (this.value.classReference ? 60 : 30),
                reference: this.value.classReference != null,
                referenceClassName: this.value.classReference,

            };
        },
        created: function () {
            // this.image = `${window.location.protocol + "//" + window.location.host}/static/image/event/event.png`
        },
        watch: {
            "value.fieldDescriptors": {
                deep: true,
                handler: _.debounce(function (newVal, oldVal) {
                    var me = this
                    me.validate(null, false)
                    me.refresh()
                }, 200)
            },
        },
        methods: {
            // close(){
            //     this.closePanel()
            // },
            validate(panelValue, executeRelateToValidate){
                var me = this
                var notPK = false
                var duplicateField = false
                var executeValidate = executeRelateToValidate == false ? false :true
                var validateValue = me.propertyPanel && panelValue ? panelValue : me.value

                // Common
                this.$super(Element).validate()

                // execute Relate Validate
                if(executeValidate) {

                }

                // Element
                if (me.canvasbase.attachedLists && Object.keys(me.canvasbase.attachedLists.aggregateLists).length > 0 ) {
                    me.attachedAggregate  = Object.values(me.canvasbase.attachedLists.aggregateLists).some(agg => {
                        if(me.isAggAttached(agg)){
                            var newAttachedAggregateId = agg.elementView.id

                            // 움직일때 AGG 변화 파악.
                            if(me.value && newAttachedAggregateId != me.attachedAggregateId){
                                // 서로 들다른 agg
                                me.attachedAggregateId = newAttachedAggregateId
                                me.canvasbase.changedTemplateCode = true
                            }
                            // validationResults
                            var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_AGG))
                            if( validationResultIndex != -1 ){
                                me.elementValidationResults.splice(validationResultIndex,1)
                            }
                            return true
                        }else{
                            // validationResults
                            var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_AGG) )
                            if( validationResultIndex == -1 ){
                                me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_AGG))
                            }
                        }
                    })
                } else {
                    // validationResults
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_AGG) )
                    if( validationResultIndex == -1 ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_AGG))
                    }
                }

                // name Validation
                if(validateValue.name){
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_NAME))
                    if( validationResultIndex != -1 ){
                        me.elementValidationResults.splice(validationResultIndex,1)
                    }
                }else{
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_NAME) )
                    if( validationResultIndex == -1 ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_NAME))
                    }
                }

                if(validateValue && validateValue.fieldDescriptors){
                    notPK =  validateValue.fieldDescriptors.findIndex(fieldDescriptor => ( fieldDescriptor.isKey == true) ) == -1
                    var filteredArray = validateValue.fieldDescriptors.filter(function(fieldDescriptor,index){
                        const fRules = (element,idx) => element.name.toLowerCase() == fieldDescriptor.name.toLowerCase()
                            && idx != index ;
                        return validateValue.fieldDescriptors.findIndex(fRules) == -1 ? false: true
                    })

                    if(filteredArray.length != 0 ){
                        duplicateField = true
                    }
                }


                if(notPK){
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_PK) )
                    if( validationResultIndex == -1 ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_PK))
                    }
                }else{
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_PK))
                    if( validationResultIndex != -1 ){
                        me.elementValidationResults.splice(validationResultIndex,1)
                    }
                }

                if(duplicateField){
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_DUPLICATE_FIELD) )
                    if( validationResultIndex == -1 ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_DUPLICATE_FIELD))
                    }
                }else{
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_DUPLICATE_FIELD))
                    if( validationResultIndex != -1 ){
                        me.elementValidationResults.splice(validationResultIndex,1)
                    }
                }

            },

        }
    }
</script>




<style scoped lang="scss" rel="stylesheet/scss">
    .panel-title {
        font-size: 25px;
        color: #757575;
    }
</style>